<template>
  <div class="contact" id="contact">
    <div class="container">
      <h1 class="section-title text-center">Contact</h1>
      <div class="row pt-5">
        <div class="col-md-4">
          <h2 class="contact-title">Support/Work Hours</h2>
          <p>
            Our support services are available
            10 Hours a day : 01-5244490/01-5244591
          </p>
          <p>Sunday - Friday : 09am - 18pm</p>
          <p>Saturday : closed</p>
        </div>
        <div class="offset-md-2 col-md-4">
          <h2 class="contact-title">Get In Touch With Us</h2>
          <div class="form">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" name="name" class="form-control" />
            </div>
            <div class="form-group">
              <label for>Email</label>
              <input type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label for>Subject</label>
              <input type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label for>Message</label>
              <textarea name id cols="30" rows="5" class="form-control"></textarea>
            </div>
            <div class="form-group submit-btn">
              <i class="fas fa-envelope mr-2"></i>
              Send Message
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>

<style scoped>
.contact {
  padding: 60px 0;
  border-top: 1px solid #e5e5e5;
}
.contact-title {
  text-transform: uppercase;
  font-size: 1.2rem !important;
  font-weight: bold;
  color: #222;
}
.contact {
  padding: 60px 0;
}

.submit-btn {
  font-size: 16px;
  text-transform: uppercase;
  border: 3px solid #111111;
  padding: 9px 20px;
  color: #111111;
  cursor: pointer;
  display: inline-block;
  margin-top: 20px;
}

.submit-btn i {
  font-size: 20px;
}
</style>